import type { TenantBranding, TTenantConfig } from './tenant.types';

// Empty primaryColor on purpose: Glomo's brand comes from the central token
// (--brand-primary). A concrete value here would be injected over that token and
// force the whole UI to it — only a real white-label tenant supplies a primaryColor.
export const DEFAULT_BRANDING: TenantBranding = {
  theme: {
    primaryColor: '',
    backgroundColor: 'var(--bg-default)',
    ringColor: 'var(--border-focus)',
  },
  logoText: null,
  logoSymbol: null,
  favicon: null,
  backgroundImage: null,
  appName: 'GlomoPay',
  supportEmail: 'support@glomopay.com',
  fontFamily: 'Inter',
  fontsCssUrl: null,
  headingFontWeight: '600',
  poweredByVisible: true,
  showOnlyHeaderLogo: false,
};

export const GLOMOPAY_DEFAULT_CONFIG: TTenantConfig = {
  isWhitelabel: false,
  authMode: 'cookie',
  selfServeOnboardingEnabled: false,
  branding: DEFAULT_BRANDING,
};
